import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LayoutWrapper from './components/layout/LayoutWrapper';
import Home from './pages/Home';
import Technology from './pages/Technology';
import Farmers from './pages/Farmers';
import Buyers from './pages/Buyers';
import Journey from './pages/Journey';
import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      <LayoutWrapper>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/our-technology" element={<Technology />} />
          <Route path="/for-farmers" element={<Farmers />} />
          <Route path="/for-buyers" element={<Buyers />} />
          <Route path="/our-journey" element={<Journey />} />
          <Route path="/contact" element={<Contact />} />
          <Route
            path="*"
            element={
              <div className="py-40 text-center">
                <h1 className="text-6xl font-extrabold text-gray-200 font-heading mb-4">404</h1>
                <p className="text-widya-body">Page not found</p>
              </div>
            }
          />
        </Routes>
      </LayoutWrapper>
    </Router>
  );
}

export default App;